export default __webpack_public_path__ + "static/media/IC3-Logo-Partner.dd440fda.svg";